exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".surewrap .dialog-warp[data-v-e43d619c]{background:#fff;box-shadow:0 0 .266667rem 0 rgba(0,0,0,.1);width:9.733333rem;height:5.346667rem;border-radius:.44rem}.surewrap .dialog-warp .title[data-v-e43d619c]{margin-top:.933333rem}.surewrap .dialog-warp .surecon-detail[data-v-e43d619c]{display:inline-block;margin:auto;margin-top:.493333rem;width:8.533333rem;height:1.946667rem;background:#f8f9fd;border-radius:.24rem}.surewrap .dialog-warp .logo[data-v-e43d619c]{width:1.28rem;height:1.28rem;position:absolute;left:50%;transform:translateX(-50%);top:-.653333rem}", ""]);

// exports
